import React from 'react';
import { connect } from 'react-redux';
import * as usersActions from 'Store/users/actions';
import { initializeList, clearNewIds } from 'Store/lists/actions';
import * as reducers from 'Store/reducers';
import { getLicenseType } from 'Settings/pricing-options';

import UsersPageHeader from 'Containers/UsersPageHeader';
import TabSwitcher from 'Components/TabSwitcher';
import InviteTeachers from 'Containers/InviteTeachers';
import ListGroup from 'Components/ListGroup';
import UsersList from 'Containers/UsersList/UsersList';
import UsersListActionBox from 'Containers/UsersListActionBox';
import AddStudent from 'Components/AddStudent';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import ListTableHeader from 'Containers/ListTableHeader';
import Loading from 'Components/Loading';

class UsersPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      requestedUsers: false,
      activeTab: 'students_in_school',
    };

    this.handleTabClick = this.handleTabClick.bind(this);
  }

  componentDidMount() {
    if (this.props.activeUser) this.fetchUsers(this.props);
  }

  handleTabClick(activeTab) {
    this.setState({ activeTab });
    this.props.clearNewIds(activeTab);
  }

  fetchUsers(props) {
    if (!this.state.requestedUsers) {
      const schoolPlanType =
        this.props.schoolLicenses && this.props.schoolLicenses[0]
          ? getLicenseType[this.props.schoolLicenses[0].license_type]
          : 'school';

      this.setState({ requestedUsers: true }, () => {
        this.props.initializeList('students_in_school', 'students_in_school');
        this.props.fetchStudentsForSchool();

        if (props.activeUser.isAdmin && schoolPlanType !== 'homeschool') {
          this.props.initializeList('teachers_in_school', 'teachers_in_school');
          this.props.fetchTeachersForSchool();
        }
      });
    }
  }

  render() {
    const { activeUser, activeSchool, isAddingAStudent, lists } = this.props;
    const { activeTab } = this.state;
    if (!activeUser || !activeSchool) return <Loading />;
    const tabData = [];

    if (lists.students_in_school)
      tabData.push({
        value: 'students_in_school',
        label: (
          <ConnectedFormattedMessage id="users_list.tab_labels.students" />
        ),
        listLength: lists.students_in_school.ids.length,
      });
    if (lists.teachers_in_school)
      tabData.push({
        value: 'teachers_in_school',
        label: (
          <ConnectedFormattedMessage id="users_list.tab_labels.teachers" />
        ),
        listLength: lists.teachers_in_school.ids.length,
      });

    const tabSwitcher = (
      <TabSwitcher
        activeTab={activeTab}
        clickHandler={this.handleTabClick}
        tabs={tabData}
      />
    );

    const activeList = this.props.lists[activeTab];
    if (!activeList) return <Loading />;

    return (
      <main className="Page__content">
        <UsersPageHeader
          activeSchool={activeSchool}
          activeTab={activeTab}
          handleTabClick={this.handleTabClick}
          tabSwitcher={tabSwitcher}
          tabData={tabData}
          message={activeList.message}
        />
        <ListGroup
          groupType="school"
          sidebar={
            <UsersListActionBox
              type={activeTab}
              listId={activeList.listId}
              groupType="school"
            />
          }
        >
          {activeTab === 'students_in_school' && isAddingAStudent ? (
            <AddStudent groupType="school" />
          ) : null}
          <UsersList
            type={activeTab}
            groupType="school"
            groupId={activeSchool.id}
            list={activeList}
            isLoading={activeList.isFetching}
            virtualized={activeList.ids.length > 100}
            rowSize="med"
          />
        </ListGroup>

        <InviteTeachers />
      </main>
    );
  }
}

const mapStateToProps = state => {
  const activeSchool = reducers.getActiveSchool(state);
  return {
    activeUser: reducers.getActiveUser(state),
    lists: {
      teachers_in_school: reducers.getListById(state, 'teachers_in_school'),
      students_in_school: reducers.getListById(state, 'students_in_school'),
    },
    isAddingAStudent: reducers.isModalActive(
      state,
      'school-students_in_school'
    ),
    activeSchool:
      activeSchool && Object.keys(activeSchool).length > 1
        ? activeSchool
        : null,
    schoolLicenses: activeSchool
      ? reducers.getLicensesForSchool(state, activeSchool.id)
      : null,
  };
};

export default connect(mapStateToProps, {
  ...usersActions,
  initializeList,
  clearNewIds,
})(UsersPage);
